import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'labelForValue',
  standalone: true,
})
export class LabelForValuePipe implements PipeTransform {
  transform(
    value: string | string[],
    allOptions: any[],
    valueKey: string = 'value',
    labelKey: string = 'label',
  ): string {
    if (!allOptions?.length) return '';

    const findLabel = (v: string) => {
      const option = allOptions.find((opt: any) => (opt[valueKey] ?? opt.value) === v);
      return option?.[labelKey] ?? option?.label ?? '';
    };

    if (Array.isArray(value)) {
      return value.map((v) => findLabel(v)).join(', ');
    }

    return findLabel(value);
  }
}
